import React from 'react';
import { Box } from '@chakra-ui/react';
import { AppSkeleton } from '@/components/ui/skeleton';
import { DocumentWithDownloadUrl as Document } from '@/client';
import FileViewer from '../../../../documents/viewers/FileViewer.tsx';

interface RecordThumbnailProps {
	document: Document;
	url: string | undefined;
	width: number;
	height: number;
	initialPage: number;
	canDownloadDocuments: boolean;
	onPreviewAspectChange: (aspect: number) => void;
}

const RecordThumbnail: React.FC<RecordThumbnailProps> = (props: RecordThumbnailProps) => {
	const { document, url, width, height, initialPage, canDownloadDocuments, onPreviewAspectChange } = props;

	return (
		<Box
			flexShrink={0}
			overflow="hidden"
			borderRadius="sm"
			borderWidth="1px"
			borderColor="border.default"
			bg="surface.default"
			boxShadow="sm"
			w={`${width}px`}
			h={`${height}px`}
		>
			{url ? (
				<FileViewer
					title={document.filename}
					fileUrl={url}
					mode="compact"
					maxWidth={width}
					filename={document.filename}
					showExternalLink={canDownloadDocuments}
					showPageControls={false}
					showPreviewHeader={false}
					disableHoverEffects={true}
					initialPage={initialPage}
					unstyledCompact={true}
					onPreviewAspectChange={onPreviewAspectChange}
				/>
			) : (
				<AppSkeleton w="full" h="full" />
			)}
		</Box>
	);
};

export default RecordThumbnail;
